'use client';

import { css, cx } from '@onbeam/business-styled-system/css';
import { IntroSectionText } from './IntroSectionText';
import { IntroSectionVideo } from './IntroSectionVideo';
import { useContainerScale } from './useContainerScale';
import { videoPositions } from './IntroSectionMobile.data';
import { motion } from 'motion/react';
import { text } from '@onbeam/business-styled-system/patterns';

export const IntroSectionMobile = ({ className }: { className?: string }) => {
  const { containerRef, scale } = useContainerScale(360);

  return (
    <motion.div
      ref={containerRef}
      className={cx(
        css({
          position: 'relative',
          w: 'full',
          h: 'auto',
          sm: { display: 'none' },
        }),
        className,
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4 }}
    >
      <svg
        width="360"
        height="456"
        viewBox="0 0 360 456"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={css({
          w: 'full',
          h: 'full',
        })}
      >
        <IntroSectionText x={2} y={30}>
          At the intersection
        </IntroSectionText>
        <IntroSectionText x={2} y={80}>
          of artificial
        </IntroSectionText>
        <IntroSectionText x={2} y={130}>
          intelligence,
        </IntroSectionText>
        <IntroSectionText x={2} y={178}>
          trading
        </IntroSectionText>
        <IntroSectionText x={2} y={228}>
          & blockchain
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={2}
          y={275}
        >
          Beam operates as
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={2}
          y={324}
        >
          an innovation lab
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={2}
          y={374}
        >
          pushing the digital
        </IntroSectionText>
        <IntroSectionText
          className={text({ fill: 'mono.tertiary!' })}
          x={2}
          y={423}
        >
          frontier.
        </IntroSectionText>
      </svg>
      {videoPositions.map((video) => (
        <IntroSectionVideo key={video.name} scale={scale} {...video} />
      ))}
    </motion.div>
  );
};
